module.exports = __webpack_public_path__ + "img/ref2.fdff2e91.png";